module.exports = __webpack_public_path__ + "img/Koehler2020.59b51f2b.jpg";